// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_a8be8d63","title":"_68ef8570","benefitsWrapper":"_528cf8c7","benefit":"_a3b21aa7","icon":"_528d4f1b","cta":"_ed3f6446"};